import { create } from "zustand";

interface InviteAgentState {
  isCompleted: boolean;
  setCompleted: (isInvited: boolean) => void;
}

export const useInviteAgentStore = create<InviteAgentState>((set) => ({
  isCompleted: false,
  setCompleted: (isCompleted) => set({ isCompleted }),
}));
